import React from 'react';
import { Link } from 'react-router-dom';
import PortalFooter from '../../components/Layout/PortalFooter';
import './ReportsHub.css';

const ReportsHub: React.FC = () => {
  return (
    <div className="reports-hub">
      <div className="reports-header">
        <h1>Farm Reports</h1>
        <p>All your farm data and analytics in one place</p>
      </div>

      <div className="reports-grid">
        {/* Order History Card */}
        <div className="report-card">
          <div className="report-icon">📋</div>
          <h3>Order History</h3>
          <p>View all past orders with search and filtering</p>
          <Link to="/portal/reports/order-history" className="report-btn">
            View Orders
          </Link>
        </div>

        {/* Year-End Report Card */}
        <div className="report-card">
          <div className="report-icon">📊</div>
          <h3>Annual Report</h3>
          <p>Yearly summary with spending trends, top products, and year-over-year comparison</p>
          <Link to="/portal/reports/annual" className="report-btn">
            View Report
          </Link>
        </div>

        {/* Batch Reports Card */}
        <div className="report-card">
          <div className="report-icon">🐔</div>
          <h3>Batch Reports</h3>
          <p>Download completion reports for harvested batches with financials and metrics</p>
          <Link to="/portal/reports/batches" className="report-btn">
            View Batches
          </Link>
        </div>

        {/* Reorder Suggestions Card */}
        <div className="report-card">
          <div className="report-icon">🔄</div>
          <h3>Reorder Suggestions</h3>
          <p>AI-powered recommendations based on your order history and usage patterns</p>
          <Link to="/portal/reports/reorder-suggestions" className="report-btn">
            View Suggestions
          </Link>
        </div>
      </div>

      <PortalFooter />
    </div>
  );
};

export default ReportsHub;
